import React from "react";
import { PlatformIcon } from "@/components/site/PlatformIcon";
import { LINK_META } from "@/data/platforms";

// Labeled streaming chips: icon + platform name, tooltip on hover.
export const PlatformRow = ({ links, fallback }) => {
  const active = Object.entries(links || {}).filter(([, url]) => url);
  if (active.length === 0) {
    if (fallback)
      return (
        <a href={fallback} target="_blank" rel="noopener noreferrer" className="pill" style={{ color: "var(--gold)" }} data-testid="listen-fallback-pill">
          Listen now<span className="sr-only">(opens in a new tab)</span>
        </a>
      );
    return <span className="pill" style={{ opacity: 0.6 }} data-testid="coming-soon-pill">Coming soon</span>;
  }
  return (
    <div className="flex flex-wrap gap-2" data-testid="platform-row">
      {active.map(([key, url]) => {
        const meta = LINK_META[key] || { name: key, icon: "" };
        return (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title={`Listen on ${meta.name}`}
            aria-label={`Listen on ${meta.name} (opens in a new tab)`}
            className="platform-chip font-caps inline-flex items-center gap-2 h-9 px-3"
            data-testid={`platform-${key}`}
          >
            <PlatformIcon name={meta.name} iconName={meta.icon} size={15} />
            <span style={{ fontSize: ".58rem", letterSpacing: ".14em" }}>{meta.name}</span>
          </a>
        );
      })}
    </div>
  );
};
